import { get } from 'lodash';
import { StringSchema } from 'yup';

export default function (this: StringSchema, message: string) {
  return this.test('unique', message, function (value) {
    const [, , { value: parent }] = this.from;
    const breakpoint = /\[\d+]./;
    const [listPath, objectKey] = this.path.split(breakpoint);

    const numberOfEqualValues = get(parent, listPath).filter((item: any) => item[objectKey] === value).length;

    if (numberOfEqualValues > 1) return false;
    return true;
  });
}
